import HealthRangeComparison from './HealthRangeComparison'

export {HealthRangeComparison}
export default HealthRangeComparison
